/**
 * Has dependency on floorplan-bundle.js
 */
import PouchLoadService from "external-services/pouch-load-service/index";

const NS = 'PlanDividerService';

export default function PlanDividerService(SnapConst, SnapService, PlanConst, Group, Structure) {
  "ngInject";

  function Divider(s, mode, model) {

    var defaults = {
      _id: PouchLoadService.getNewId(['structure']),
      type: Structure.Type,
      subType: Structure.SubTypes.Wall,
      width: 80,
      height: 5,
      rotation: 0,
      position: {
        x: 0,
        y: 0
      }
    };

    this.s = s;
    this.mode = mode;
    defaults.width = this.mode === PlanConst.Mode.Restaurant ? 160 : 80;
    this.model = _.extend({}, defaults, model);

    //Fix old data, divider saved with height 10 are not valid
    this.model.height = 5;

    this.resizable = _.clone(Divider.Resizable);
    this.actions = _.clone(Divider.Actions);

    this.render();
    this.refresh();
    this.rotate(this.model.rotation);
    this.place(this.model.position);
  }

  Divider.prototype = _.extend({}, new Structure(), {
    render: function () {
      this.element = new Group(this.s, 'Divider', {
        type: SnapConst.Shapes.Rect,
        w: this.model.width,
        h: this.model.height
      });
      SnapService.getElement(this.element).addClass('structure divider ' + this.model.subType).data()._id = this.model._id;
      //Body
      this.body = this.s.rect(0, 0, this.model.width, this.model.height).addClass('body');
      this.element.addElement(this.body, 'body');
      //Core
      this.core = this.s.rect(0, 0, this.model.width - 2, this.model.height - 2).addClass('core');
      SnapService.place(this.core, 1, 1);
      this.element.addElement(this.core, 'core');
    },

    refresh: function (anchor) {
      var info = this.beforeResize(anchor);

      this.element.shape.w = this.model.width;
      this.element.shape.h = this.model.height;
      this.shape = this.element.shape;
      this.body.attr({
        width: this.model.width,
        height: this.model.height
      });
      this.core.attr({
        width: this.model.width - 2,
        height: this.model.height - 2
      });

      this.afterResize(info);
    }
  });

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  Divider.Resizable = {
    hStep: 0,
    hMin: 5,
    hMax: 5,
    wStep: 10,
    wMin: 20,
    wMax: -1
  };

  Divider.Actions = {
    spread: true,
    rotate: true,
    edit: true
  };

  Divider.buildToolbarElement = function (s, type) {
    var g = new Group(s, 'Divider', {
      type: SnapConst.Shapes.Rect,
      w: 80,
      h: 30
    });
    g.getSGroup().data('type', type);
    g.getSGroup().addClass('structure ' + type);
    var body = s.rect(0, 0, 80, 10).addClass('body');
    g.addElement(body, 'body');
    SnapService.place(body, 0, 0);
    var core = s.rect(0, 0, 78, 8).addClass('core');
    g.addElement(core, 'core');
    SnapService.place(core, 1, 1);
    var label = s.text(0, 0, Structure.getTypeName(type)).addClass('label');
    g.addElement(label, 'label');
    SnapService.place(label, 80 / 2, 20);
    return g;
  };

  return Divider;
}
